export enum NotificationVariant {
  DEFAULT = 'default',
  ABOVE_STICKY_FOOTER = 'aboveStickyFooter',
}
